import { BaseModel } from "sjs-base-model";

export default class ProjectPhotoChannelModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<ProjectPhotoChannelModel>) {
    super();

    this.update(data);
  }
}
